import { Route, Routes } from 'react-router';
import type { MultiLang } from '../config';
import Database from '../database/Database';
import DatabaseXoopsPathRedirect from '../database/DatabaseXoopsPathRedirect';
import About from './About';
import styles from './MainContent.module.css';
import XoopsPathRedirect from './XoopsPathRedirect';

interface Props {
    lang: MultiLang;
}

const MainContent = (props: Props) => {
    const { lang } = props;
    return (
        <div className={styles.mainContent}>
            <Routes>
                <Route path="/database/*" element={<Database lang={lang} />} />
                <Route path="/about" element={<About />} />
                <Route path="/modules/xoonips/*" element={<DatabaseXoopsPathRedirect lang={lang} />} />
                <Route path="*" element={<XoopsPathRedirect lang={lang} />} />
            </Routes>
        </div>
    );
};

export default MainContent;
